import * as Constant from '../Constants/Constant';

export const MENU_GROUPS_GENERAL = [
    {
        name: 'Shipping',
        children: [
            {
                name: 'New Shipping',
                tabStatus: Constant.REPAIRREQUEST_STAT_NEW_SHIPMENT,
            },
            { name: 'History', tabStatus: Constant.REPAIRREQUEST_STAT_HISTORY },
        ],
    },
    {
        name: 'Protection Plan',
        children: [
            {
                name: 'Register',
                tabStatus: Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_REGISTER,
            },
            {
                name: 'History',
                tabStatus: Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_HISTORY,
            },
        ],
    },
    {
        name: 'Gen1',
        children: [
            {
                name: 'Application',
                tabStatus: Constant.REPAIRREQUEST_STAT_GEN1_APPLICATION,
            },
            {
                name: 'History',
                tabStatus: Constant.REPAIRREQUEST_STAT_GEN1_HISTORY,
            },
        ],
    },
    {
        name: 'User Setting',
        tabStatus: Constant.REPAIRREQUEST_STAT_USERSETTING,
    },
    { name: 'Contact Us', tabStatus: Constant.REPAIRREQUEST_STAT_CONATCTUS },
];

export const MENU_GROUPS_REPAIR_CENTER = [
    {
        name: 'Protection Plan',
        children: [
            {
                name: 'History',
                tabStatus: Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_HISTORY,
            },
        ],
    },
    {
        name: 'User Setting',
        tabStatus: Constant.REPAIRREQUEST_STAT_USERSETTING,
    },
    { name: 'Contact Us', tabStatus: Constant.REPAIRREQUEST_STAT_CONATCTUS },
];

/** Primary → 必須 History（サーバー MenuPermissionService と同義） */
export const PRIMARY_HISTORY_PAIRS = [
    {
        primary: Constant.REPAIRREQUEST_STAT_NEW_SHIPMENT,
        history: Constant.REPAIRREQUEST_STAT_HISTORY,
    },
    {
        primary: Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_REGISTER,
        history: Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_HISTORY,
    },
    {
        primary: Constant.REPAIRREQUEST_STAT_GEN1_APPLICATION,
        history: Constant.REPAIRREQUEST_STAT_GEN1_HISTORY,
    },
];

/** tabStatus が属する機能ファミリー内の tabStatus 一覧（メニュー定義順） */
const TAB_FAMILY_MAP = new Map();
(function buildTabFamilyMap() {
    [MENU_GROUPS_GENERAL, MENU_GROUPS_REPAIR_CENTER].forEach((groups) => {
        (groups || []).forEach((group) => {
            if (!group?.children?.length) return;
            const family = group.children.map((c) => c.tabStatus);
            family.forEach((tab) => TAB_FAMILY_MAP.set(tab, family));
        });
    });
})();

export function flattenTabStatuses(menuGroups) {
    const statuses = [];
    (menuGroups || []).forEach((item) => {
        if (item?.children?.length) {
            item.children.forEach((c) => statuses.push(c.tabStatus));
        } else if (item?.tabStatus) {
            statuses.push(item.tabStatus);
        }
    });
    return statuses;
}

export function filterMenuGroupsByAllowed(menuGroups, allowedSet) {
    return (menuGroups || [])
        .map((item) => {
            if (item?.children?.length) {
                const children = item.children.filter((c) =>
                    allowedSet.has(c.tabStatus)
                );
                if (children.length === 0) return null;
                return { ...item, children };
            }
            if (!item?.tabStatus) return null;
            if (!allowedSet.has(item.tabStatus)) return null;
            return item;
        })
        .filter(Boolean);
}

export function getDefaultMenuGroupsForUser(userInformation) {
    return userInformation?.RepairCenterFlag
        ? MENU_GROUPS_REPAIR_CENTER
        : MENU_GROUPS_GENERAL;
}

/**
 * Primary 付与時は History を自動付与。History なしで Primary だけは残さない。
 * サーバー NormalizeAllowedTabStatuses と同じルール。
 */
export function normalizeAllowedTabStatuses(codes) {
    const set = new Set(
        (codes || []).filter((x) => typeof x === 'string' && x.trim())
    );
    PRIMARY_HISTORY_PAIRS.forEach(({ primary, history }) => {
        if (set.has(primary)) set.add(history);
    });
    return Array.from(set);
}

export function getAllowedSetForUser(userInformation) {
    const baseGroups = getDefaultMenuGroupsForUser(userInformation);
    const defaultAllowed = flattenTabStatuses(baseGroups);
    const allowed = userInformation?.AllowedTabStatuses;
    const list = Array.isArray(allowed) ? allowed : defaultAllowed;
    return new Set(normalizeAllowedTabStatuses(list));
}

export function getMenuGroupsForUser(userInformation) {
    const baseGroups = getDefaultMenuGroupsForUser(userInformation);
    const allowedSet = getAllowedSetForUser(userInformation);
    return filterMenuGroupsByAllowed(baseGroups, allowedSet);
}

export function getFirstAllowedTabStatus(userInformation, fallbackTabStatus) {
    const baseGroups = getDefaultMenuGroupsForUser(userInformation);
    const allowedSet = getAllowedSetForUser(userInformation);
    const flattened = flattenTabStatuses(baseGroups).filter((x) =>
        allowedSet.has(x)
    );
    return flattened[0] || fallbackTabStatus;
}

export function hasTab(userInformation, tabStatus) {
    if (!tabStatus) return false;
    return getAllowedSetForUser(userInformation).has(tabStatus);
}

export function hasGen1AppTab(userInformation) {
    return hasTab(
        userInformation,
        Constant.REPAIRREQUEST_STAT_GEN1_APPLICATION
    );
}

export function hasGen1HistTab(userInformation) {
    return (
        hasTab(userInformation, Constant.REPAIRREQUEST_STAT_GEN1_HISTORY) ||
        hasGen1AppTab(userInformation)
    );
}

export function hasProtectionPlanRegisterTab(userInformation) {
    return hasTab(
        userInformation,
        Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_REGISTER
    );
}

export function hasProtectionPlanHistTab(userInformation) {
    return (
        hasTab(
            userInformation,
            Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_HISTORY
        ) || hasProtectionPlanRegisterTab(userInformation)
    );
}

export function hasShippingNewTab(userInformation) {
    return hasTab(userInformation, Constant.REPAIRREQUEST_STAT_NEW_SHIPMENT);
}

export function hasShippingHistTab(userInformation) {
    return (
        hasTab(userInformation, Constant.REPAIRREQUEST_STAT_HISTORY) ||
        hasShippingNewTab(userInformation)
    );
}

/**
 * 許可外 tabStatus への遷移時、同一機能ファミリー内の許可タブへフォールバック。
 * 該当なしのとき null（Shipping 等へ飛ばさない）。
 */
export function resolveTabFallback(userInformation, attemptedTabStatus) {
    const family = TAB_FAMILY_MAP.get(attemptedTabStatus);
    if (!family?.length) return null;
    const allowedSet = getAllowedSetForUser(userInformation);
    return family.find((tab) => allowedSet.has(tab)) ?? null;
}

/** Component Select 用: feature は 'shipping' | 'protectionPlan' | 'gen1' */
export function getPreferredTabForFeature(userInformation, feature) {
    switch (feature) {
        case 'shipping':
            if (hasShippingNewTab(userInformation)) {
                return Constant.REPAIRREQUEST_STAT_NEW_SHIPMENT;
            }
            if (hasShippingHistTab(userInformation)) {
                return Constant.REPAIRREQUEST_STAT_HISTORY;
            }
            return null;
        case 'protectionPlan':
            if (hasProtectionPlanRegisterTab(userInformation)) {
                return Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_REGISTER;
            }
            if (hasProtectionPlanHistTab(userInformation)) {
                return Constant.REPAIRREQUEST_STAT_PROTECTIONPLAN_HISTORY;
            }
            return null;
        case 'gen1':
            if (hasGen1AppTab(userInformation)) {
                return Constant.REPAIRREQUEST_STAT_GEN1_APPLICATION;
            }
            if (hasGen1HistTab(userInformation)) {
                return Constant.REPAIRREQUEST_STAT_GEN1_HISTORY;
            }
            return null;
        default:
            return null;
    }
}
